import React from 'react';

/* I messaggi del Self-Assessment usano la formattazione di WhatsApp
   (*grassetto*, _corsivo_) perché lo stesso testo va su entrambi i canali;
   il modello a volte scrive **grassetto**. Qui si rende come testo
   formattato, senza HTML iniettato: prima l'utente vedeva gli asterischi. */
// Il corsivo vale solo a inizio parola: «mario_rossi_x@...» resta com'è.
const MARCATORI = /(\*\*[^*\n]+\*\*|\*[^*\n]+\*|(?<![\w])_[^_\n]+_(?![\w]))/g;

function formatta(text) {
  if (typeof text !== 'string') return text;
  return text.split(MARCATORI).map((parte, i) => {
    if (/^\*\*[^*\n]+\*\*$/.test(parte)) return <strong key={i}>{parte.slice(2, -2)}</strong>;
    if (/^\*[^*\n]+\*$/.test(parte)) return <strong key={i}>{parte.slice(1, -1)}</strong>;
    if (/^_[^_\n]+_$/.test(parte)) return <em key={i}>{parte.slice(1, -1)}</em>;
    return parte;
  });
}

export default function MessageBubble({ role, text, isError }) {
  const roleClass = role === 'user' ? 'sa-bubble-row--user' : 'sa-bubble-row--bot';
  const bubbleClass = [
    'sa-bubble',
    role === 'user' ? 'sa-bubble--user' : 'sa-bubble--bot',
    isError ? 'sa-bubble--error' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={`sa-bubble-row ${roleClass}`}>
      <div className={bubbleClass} role={isError ? 'alert' : undefined}>
        {role === 'user' ? text : formatta(text)}
      </div>
    </div>
  );
}
